import Vue from 'vue'
import App from './App.vue'
import router from './router'

// UI框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 自定义样式
import './style.less'

// 配置
import config from './config'
Vue.prototype.$config = config

// 服务器交互
import http from './libs/http'
Vue.prototype.$http = http

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
